import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import HairConsult from "@/pages/HairConsult";
import Admin from "@/pages/Admin";
import ResetAccess from "@/pages/ResetAccess";

const root = ReactDOM.createRoot(document.getElementById("root"));
const path = window.location.pathname;
const page = path.startsWith("/reset")
  ? <ResetAccess />
  : path.startsWith("/admin")
    ? <Admin />
    : <HairConsult />;
root.render(
  <React.StrictMode>
    {page}
  </React.StrictMode>,
);
